import { Component, Injector} from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material";
import { FormControl, FormGroup, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { ErrorStateMatcher } from '@angular/material/core';
import * as moment from 'moment';
import Swal from "sweetalert2";
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesSimuladorAgregarDetalle } from '../../../models/messages';
import { ProformaDetalle } from '../../../models/ProformaDetalle';
import { DocumentoNegociableService } from '../../../services/documento-negociable/documento-negociable.service';
import { LocalService } from './../../../services/storage/localService';
import { ProformaService } from './../../../services/operaciones/proforma/proforma.service';
import { LoginService } from 'app/services/login/login.service';
import { GuiasService } from 'app/services/guias/guias.service';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { environment } from 'environments/environment';
import { OperacionService } from '../../../services/operaciones/operacion/operacion.service';
import {FiltrosOperacion} from '../../../models/FiltrosOperacion';
import { CobranzasService } from '../../../services/cobranzas/cobranzas.service';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;

@Component({
  selector: 'app-nuevo-proforma',
  templateUrl: './nuevo-proforma.component.html',
  styleUrls: ['./nuevo-proforma.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesDates, MessagesSimuladorAgregarDetalle,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})

export class NuevoProformaComponent{
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Proformas=environment.LABEL_PROFORMAS;
  Label_Proforma=environment.LABEL_PROFORMA;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  Id_Descuento=environment.ID_DESCUENTO;
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;
  
  operacionProv:any = [];
  linea:any = [];
  totalVnpp: any = 0;
  varDiasMin: any = 0;
  varDiasMax: any = 0;
  varAdelantoMin: any = 0;
  varAdelantoMax: any = 0;
  varAdelantoDef: any = 0;
  varTasaMin: any = 0;
  varTasaMax: any = 0;
  IGV_Porcentaje: any = 0;
  igvPorcentajeGlobal: any = 0;
  flgCalcular: boolean = false;
  arrayDocumentos: any = [];
  actualizarDocumentos: any = [];
  user: any;
  minFromDate = new Date();
  nroFacturas: number =0;
  TEM: number = 0;
  TemEdit: number = 0;
  TEMAutomatico: number = 0;
  flgTEMAutomatico: boolean = false;
  flgNotificar: boolean = false;
  loading: boolean = false;
  formTEM: FormGroup;
  formProforma: FormGroup;
  proformaDetalle: ProformaDetalle[] = [];
  rProveedor: any = [];
  Nombre_de_Contacto: string = "";
  correo: string = "";
  idProforma: number = 0;
  idProveedor: number = 0;
  ProformaSave: any = [];
  optionValue;
  tipoServicioElement = this.Id_Factoring;
  sumainteres: number = 0;
  ocultarAdq: boolean = false;
  comisionPeso: number = 0; ç
  prospectoFiltroAdq: any;
  prospectoFiltroProv: any;
  boton: boolean = true;
  ProformaTotales: any = {
    VNPP: 0,
    Adelanto: 0,
    Interes: 0,
    InteresAdq: 0,
    InteresProv: 0,
    Comision: 0,
    IGV_TOTAL: 0,
    Desembolso: 0,
    Remanente: 0,
    IGVProv: 0,
    CAVALI: 0,
    Firma: 0, 
    Otros : 0,
    Desembolso_importe : 0, 
    DesembolsoProvConfirming: 0,
    Costo_Total_Operacion: 0,
    TAI: 0,
    Plazo:0
  };

  ProformaConDetalle: any = {
    proforma_detalle: [],
    idEmpresa: 1
  };

  datosDN: any;
  check0: boolean = false;
  flagRepro: boolean = false;
  Date = new Date();
  PlazoMaximo = 0;

  proformaGeneral: any = {
    "Num_Doc_Identificacion_Prov": "",
    "Num_Doc_Identificacion_ADQ": "",
    "Ranking_Adquirente": "",
    "Tasa_Tipo_de_Calculo": "",
    "Tasa_Anual": "",
    "Tasa_Mensual_Sistema": "",
    "Tasa_Mensual": "",
    "Tasa_Diaria": "",
    "Moneda": "",
    "Adelanto_porcentaje": "",
    "Cantidad_de_Documentos_Negociables": "",
    "Fecha_Desembolso": "",
    "Fecha_Vigencia": "",
    "Adjunto_PDF": "",
    "TAI": "",
    "IdOpeNova": "",
    "TasaProrroga": "",
    "ProformaDetalle": []
  }

  empresasService: EmpresasService;
  proformaService: ProformaService;
  documentoNegociableService: DocumentoNegociableService;
  loginService: LoginService;
  localService: LocalService;
  guiasService: GuiasService;
  
  DTOFiltrosOperacion: FiltrosOperacion = new FiltrosOperacion();

  constructor(private injector : Injector,
    private datepipe: DatePipe,
    private msgAgregarSimulador: MessagesSimuladorAgregarDetalle,
    private msgTitulos: MessagesTitles,
    private router: Router,
    private operacionService:OperacionService,
    private cobranzasService: CobranzasService
  ){
    this.empresasService = this.injector.get<EmpresasService>(EmpresasService);
    this.proformaService = this.injector.get<ProformaService>(ProformaService);
    this.documentoNegociableService = this.injector.get<DocumentoNegociableService>(DocumentoNegociableService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.localService = this.injector.get<LocalService>(LocalService);
    this.guiasService = this.injector.get<GuiasService>(GuiasService);

    this.varDiasMin = this.localService.getJsonValue('ParametroRechazoMin');
    this.varDiasMax = this.localService.getJsonValue('ParametroRechazoMax');
    this.varAdelantoMin = (this.localService.getJsonValue('ParametroAdelantoMinimo') * 100);
    this.varAdelantoMax = (this.localService.getJsonValue('ParametroAdelantoMaximo') * 100);
    this.varAdelantoDef = (this.localService.getJsonValue('ParametroAdelandoDefault') * 100);
    this.varTasaMin = this.localService.getJsonValue('ParametroTasaMinimoComercial');
    this.varTasaMax = this.localService.getJsonValue('ParametroTasaMaximo');
    this.igvPorcentajeGlobal = this.localService.getJsonValue('ParametroIGVPorcentaje');
    
  this.minFromDate.setDate(this.minFromDate.getDate() - 30);
    try {
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.datosDN = this.proformaService.datosProforma;
      console.log('datosproforma',this.datosDN);
      this.flagRepro = (this.datosDN.TipoOperacion=='Reprogramado')? true:false;
      this.validarProvAdq(this.datosDN.Num_Doc_Identificacion_Prov,this.datosDN.Num_Doc_Identificacion_Adq);
      this.ObtenerDocumentosNegociables();
      
    } catch (error) {
      this.loginService.clickGuard = true;
      this.router.navigate(['/operaciones/proformas/listado']);
    }

    let now = moment();

    this.formTEM = new FormGroup({
      'Plazo': new FormControl(''),
      'VNPP': new FormControl(''),
      'NombreComercialProv': new FormControl(this.datosDN.NombreComercialProv),
      'NombreComercialAdq': new FormControl(this.datosDN.NombreComercialAdq),
      'ProveedorScore': new FormControl(this.datosDN.ScoringProv),
      'AdquirenteScore': new FormControl(this.datosDN.ScoringAdq),
      'Num_Doc_Identificacion_Prov': new FormControl(this.datosDN.Num_Doc_Identificacion_Prov),
      'Num_Doc_Identificacion_ADQ': new FormControl(this.datosDN.Num_Doc_Identificacion_Adq),
      'ValorTipoCambio': new FormControl(3.33),
      'TipoCambio': new FormControl(this.datosDN.TipoCambio),
      'Moneda_Dsc': new FormControl(this.datosDN.Moneda_Dsc),
      'Adelanto_Porcentaje': new FormControl(90, [Validators.required, Validators.pattern('^[0-9.]+$')]),
      'Tipo_Comprobante': new FormControl((this.datosDN.Tipo_Comprobante == 'F') ? 'Factura' : 'Compromiso de Pago'),
      'Fecha_Desembolso': new FormControl(now),
      'Ranking': new FormControl(''),
      'Interes_Adquirente': new FormControl(0, [Validators.pattern('^[0-9.]+$')]),
      'Tipo_Servicio': new FormControl('', [Validators.required]),
      'Importe_Adquirente': new FormControl(0),
      'Comision': new FormControl(0),
      'Comision_Porcentaje': new FormControl(0), 
      'Aforo_Porcentaje': new FormControl(0),  
      'Otros': new FormControl(0),
      "IdOpeNova": new FormControl(0),
      "PlazoProforma": new FormControl('30'),
      "Fecha_Pago_Operacion": new FormControl(0),
      "Prorroga_Porcentaje": new FormControl(),
      "Prorroga_Monto": new FormControl(),
      "Prorroga_Iva": new FormControl(),
      "Prorroga_Total": new FormControl(),
      
    });

    this.formProforma = new FormGroup({
      Fecha: new FormControl(''),
      VNPP: new FormControl(''),
      Tipo_Comprobante: new FormControl(''),
      Fecha_Desembolso: new FormControl(''),
      Moneda: new FormControl(''),
      TEM: new FormControl(''),
      Adelanto_Porcentaje: new FormControl(''),
      Adelanto_Importe: new FormControl(''),
      Interes_Importe: new FormControl(''),
      Comision_Importe: new FormControl(''),
      IGV_Importe: new FormControl(''),
      Desembolso_Importe: new FormControl(''),
      Remanente_Importe: new FormControl(''),
      Num_Doc_IdentificacionP: new FormControl(''),
      Num_Doc_IdentificacionA: new FormControl('')
    });

    this.tipoServicio(this.Id_Factoring);
  }
  
  ngOnInit() {  
    this.calculateFechaPago('');
  }
  calcularComision(){
    let porcentaje = this.formTEM.controls['Comision_Porcentaje'].value;
    let adelantoPercent = this.formTEM.controls['Adelanto_Porcentaje'].value;
    
    let comision = this.ProformaTotales.VNPP*(adelantoPercent/100) * porcentaje/100;
    console.log('calcular comision 111',porcentaje,comision);
    this.formTEM.controls['Comision'].setValue(Math.round(comision*100)/100);
  }
  calcularPorcentaje(){
    let comision = this.formTEM.controls['Comision'].value;
    let adelantoPercent = this.formTEM.controls['Adelanto_Porcentaje'].value;
    let porcentaje = comision/(this.ProformaTotales.VNPP*(adelantoPercent/100)) *100;
    console.log('calcular comision',porcentaje,comision);
    this.formTEM.controls['Comision_Porcentaje'].setValue(Math.round(porcentaje*100)/100);
  }
  calcularTasaAllIn(){ 
    let tasaArray = Array();
    let i = 0;
    this.proformaDetalle.forEach(element => {
      if (element.checked) {
        console.log("ElementData",element);
        tasaArray[i] = (((Number(element.VNPP)/this.ProformaTotales.VNPP)*Number(this.ProformaTotales.Comision))+element.Interes_importe)/Number(element.VNPP)/element.Plazo*30*Number(element.VNPP);
        i++;
      }
    });
    console.log("tarasarray",tasaArray);
    let totalAll = 0;
    tasaArray.forEach( element =>{
      totalAll+=element
    }) 
    console.log("TotalAll", totalAll);
    console.log("VNPPP",this.ProformaTotales.VNPP);
    let tasa = totalAll/this.ProformaTotales.VNPP*100;
     console.log("TasaAllincal",tasa);
    this.ProformaTotales.TAI= Math.round(tasa*100)/100;
  }

  calcularProforma(modo : boolean, TEM: number){
    this.resetear();
    this.loading = true;
    let plazo: any = [];
    this.PlazoMaximo = 0;
    let sumaVNPP: number = 0.00;
    let TEM_Re: number = 0.00;
    this.TEM = 0;
    this.nroFacturas = 0;
    this.PlazoMaximo = this.formTEM.controls['PlazoProforma'].value * 1;
    for (let item of this.proformaDetalle) {
      if (item.checked) {
        this.nroFacturas++;
        //plazo.push(item.Plazo);
        item.Plazo = this.PlazoMaximo
        sumaVNPP += Number(item.VNPP);
        TEM_Re = item.Tasa;
      }
    }

    //if (plazo.length > 0) this.PlazoMaximo = Math.max(...plazo);

    this.formTEM.controls['TipoCambio'].setValue(this.datosDN.TipoMoneda);
    this.formTEM.controls['Num_Doc_Identificacion_Prov'].setValue(this.datosDN.Num_Doc_Identificacion_Prov);
    this.formTEM.controls['Num_Doc_Identificacion_ADQ'].setValue(this.datosDN.Num_Doc_Identificacion_Adq);
    this.formTEM.controls['Plazo'].setValue(this.PlazoMaximo);
    this.formTEM.controls['VNPP'].setValue(sumaVNPP);
 

    if(this.formTEM.value.Comision == ''){ this.formTEM.controls['Comision'].setValue(0); } 
    if(this.formTEM.value.Comision_Porcentaje == ''){ this.formTEM.controls['Comision_Porcentaje'].setValue(0); } 
    if(this.formTEM.value.Aforo_Porcentaje == ''){ this.formTEM.controls['Aforo_Porcentaje'].setValue(0); } 
    if(this.formTEM.value.Otros == ''){ this.formTEM.controls['Otros'].setValue(0); } 

    if(this.formTEM.value.VNPP>0){
      this.proformaService.obtenerTEM(this.formTEM.value,1).subscribe(
        responseTEM => { 
          this.TEMAutomatico = (this.flagRepro)? Number(TEM_Re):Number(responseTEM);
          this.TEMAutomatico = (this.TemEdit > 0)? Number(this.TemEdit):Number(responseTEM);
          if(modo){
            this.TEM = this.TEMAutomatico;
            this.flgTEMAutomatico = false; 
          } else {
            this.TEM = TEM;
            this.flgTEMAutomatico = true; 
          }
          let cont_facturas = 0;
          this.proformaDetalle.forEach((item,index)=>{
            this.sumainteres = 0;
            if (item.checked){
              item.TEM = this.TEM;
              item.pPAdelanto  =  this.formTEM.controls['Adelanto_Porcentaje'].value/100;
              item.Moneda =  this.formTEM.controls['TipoCambio'].value;
              item.Porcentaje_Interes_Adquirente = this.formTEM.controls['Interes_Adquirente'].value/100;
              item.Tipo_Servicio = this.formTEM.controls['Tipo_Servicio'].value;
              item.Comision_importe = this.formTEM.controls['Comision'].value;
              item.Otros_Descuentos = this.formTEM.controls['Otros'].value;
              item.Aforo_Porcentaje = this.formTEM.controls['Aforo_Porcentaje'].value;
              item.nroFacturas = this.nroFacturas;

              
              this.proformaService.factoring(item,1).subscribe(
                responseFactoring => {
                  this.proformaDetalle[index].Adelanto_importe = responseFactoring['Adelanto'];
                  this.proformaDetalle[index].Remanente_importe = responseFactoring['Remanente'];
                  this.proformaDetalle[index].Interes_importe = responseFactoring['Interes'];
                  this.proformaDetalle[index].InteresProv = responseFactoring['InteresProv'];
                  this.proformaDetalle[index].InteresAdq = responseFactoring['InteresAdq'];
                  this.proformaDetalle[index].IGVProv = responseFactoring['IGVProv'];
                  this.proformaDetalle[index].IGV = responseFactoring['IGV'];
                  this.proformaDetalle[index].IGVAdq = responseFactoring['IGVAdq'];
                  this.proformaDetalle[index].CAVALI_importe = responseFactoring['Timbre'];
                  this.proformaDetalle[index].firma_importe = responseFactoring['Feci'];
                  this.proformaDetalle[index].otros_importe = responseFactoring['G_cesion'];
                  this.proformaDetalle[index].Comision_importe = responseFactoring['Comision'];
                  
                  this.proformaDetalle[index].Desembolso_importe = responseFactoring['Desembolso'];
                  
                  this.proformaDetalle[index].DesembolsoProvConfirming = this.proformaDetalle[index].Desembolso_importe;
                  
                  
                  this.ProformaTotales.VNPP += Number(this.proformaDetalle[index].VNPP);
                  this.ProformaTotales.Adelanto += Number(responseFactoring['Adelanto']);
                  this.ProformaTotales.Interes += Number(responseFactoring['Interes']);
                  this.ProformaTotales.Remanente += Number(responseFactoring['Remanente']);
                  this.ProformaTotales.CAVALI += Number(responseFactoring['Timbre']);
                  this.ProformaTotales.Firma += Number(responseFactoring['Feci']);
                  this.ProformaTotales.Otros += Number(responseFactoring['G_cesion']);
                  this.ProformaTotales.Comision += Number(responseFactoring['Comision']);
                  this.ProformaTotales.IGVProv += Number(responseFactoring['IGV']);
                  this.ProformaTotales.Desembolso_importe += Number( this.proformaDetalle[index].Desembolso_importe);                  
                  this.ProformaTotales.Costo_Total_Operacion += Number(responseFactoring['Costo_Total_Operacion']);
                  this.ProformaTotales.Plazo = this.PlazoMaximo;
                  cont_facturas++;  
                  if(this.nroFacturas == cont_facturas){

                    this.ProformaTotales.NroFacturas = this.nroFacturas;
                    this.ProformaTotales.Moneda = this.datosDN.TipoMoneda;

                    this.calcularTasaAllIn();
                    this.calcularPorcentaje();
                    this.calcularProrroga();
                    this.formTEM.controls['Importe_Adquirente'].setValue( Math.round(this.ProformaTotales.Costo_Total_Operacion * 100) / 100); 
                    this.proformaService.factoringResume(this.ProformaTotales,1).subscribe(
                      responseResumen => {
                          let cargoAdqIgvTotal = 0;
                          let cargoProvIgvTotal = 0;
                          this.proformaDetalle.forEach((row,position)=>{
                            let montoComision = 0;
                            let comisionAdq = 0;
                            let comisionProv = 0;
                            let desembolsoImporte = 0;
                            let desembolsoProv = 0;
                            let cargoProv = 0;
                            let cargoProvIgv = 0;
                            let cargoAdq = 0;
                            let cargoAdqIgv = 0;

                            montoComision = row.Adelanto_importe * responseResumen['Comision_peso'];
                            comisionAdq = montoComision * (this.formTEM.controls['Interes_Adquirente'].value/100);
                            cargoAdq = comisionAdq + row.InteresAdq;
                            cargoAdqIgv = cargoAdq * this.IGV_Porcentaje;
                            cargoAdqIgvTotal += cargoAdq + cargoAdqIgv;
                            comisionProv = montoComision - comisionAdq;
                            cargoProv = comisionProv + row.InteresProv;
                            cargoProvIgv = cargoProv * this.IGV_Porcentaje;
                            cargoProvIgvTotal += cargoProv + cargoProvIgv;

                           // this.proformaDetalle[position].ComisionTotal = Math.round(montoComision * 100)/100;
                          //  this.proformaDetalle[position].Comision_importe = Math.round(comisionProv * 100) / 100;
                           /* this.proformaDetalle[position].IGV_Importe = Math.round((row.Interes_importe + montoComision)* this.IGV_Porcentaje * 100)/100;
                            this.proformaDetalle[position].IGVProv = Math.round(cargoProvIgv * 100)/100;
                            this.proformaDetalle[position].IGVAdq = Math.round(cargoAdqIgv * 100)/100;
                            this.proformaDetalle[position].IGV_porcentaje = this.IGV_Porcentaje;
                            this.proformaDetalle[position].Porcentaje_Interes_Adquirente = this.formTEM.controls['Interes_Adquirente'].value/100;*/

                            desembolsoProv = row.Adelanto_importe - (row.InteresProv + row.Comision_importe + row.IGVProv);
                            desembolsoImporte = desembolsoProv - cargoAdqIgvTotal;

                          /*  this.proformaDetalle[position].DesembolsoProvConfirming = Math.round(desembolsoProv * 100)/100;
                            this.proformaDetalle[position].Desembolso_importe = Math.round(desembolsoImporte * 100)/100;

                            this.proformaDetalle[position].Factoring_importe = Math.round((row.Interes_importe + montoComision) * 100)/100;
                            this.proformaDetalle[position].Factoring_SUNAT_importe = Math.round((row.Interes_importe + montoComision + this.proformaDetalle[position].IGV_Importe)* 100)/100;
*/
                          /*  this.ProformaTotales.InteresAdq += Number(this.proformaDetalle[position].InteresAdq);
                            this.ProformaTotales.InteresProv += Number(this.proformaDetalle[position].InteresProv);
                            this.ProformaTotales.Interes_Importe += Number(this.proformaDetalle[position].Interes_importe);
                            this.ProformaTotales.Comision += Number(this.proformaDetalle[position].Comision_importe);
                            this.ProformaTotales.IGVProv += Number(this.proformaDetalle[position].IGVProv);
                            this.ProformaTotales.IGVAdq += Number(this.proformaDetalle[position].IGVAdq);
                            this.ProformaTotales.IGV_TOTAL += Number(this.proformaDetalle[position].IGVProv + this.proformaDetalle[position].IGVAdq);
                            this.ProformaTotales.DesembolsoProvConfirming += Number(this.proformaDetalle[position].DesembolsoProvConfirming);
                            this.ProformaTotales.Desembolso_importe += Number(this.proformaDetalle[position].Desembolso_importe);*/
                          }) 
                          this.flgCalcular = true;
                          this.loading = false;
                      }, error =>{
                        this.loading = false;
                      }
                    )
                  }
                }
              )
            } else {
              this.proformaDetalle[index].Adelanto_importe = 0;
              this.proformaDetalle[index].Remanente_importe = 0;
              this.proformaDetalle[index].Desembolso_importe = 0;
              this.proformaDetalle[index].Comision_importe = 0;
              this.proformaDetalle[index].Interes_importe = 0;
              this.proformaDetalle[index].InteresAdq = 0;
              this.proformaDetalle[index].InteresProv = 0;
              this.proformaDetalle[index].IGV_Importe = 0;
              this.proformaDetalle[index].IGV_porcentaje = 0;
              this.proformaDetalle[index].IGVProv = 0;
              this.proformaDetalle[index].DesembolsoProvConfirming = 0;

              this.ProformaTotales = {
                VNPP : 0,
                Adelanto :  0,
                Interes :  0,
                InteresAdq :  0,
                InteresProv :  0,
                Comision :  0,
                IGV_TOTAL :  0,
                Desembolso :  0,
                Remanente :  0,
                IGVProv : 0,
                CAVALI : 0,
                Firma : 0,
                Otros : 0,
                Desembolso_importe : 0, 
                DesembolsoProvConfirming : 0,
                Costo_Total_Operacion : 0
              };
            }
          }) 
          
        });
    } else {
      this.resetear();
      this.loading = false;
    }
  }
  
  ObtenerRanking() {
    this.proformaService.obtenerLineaEmpresa(this.datosDN.idProveedor,this.datosDN.TipoMoneda).subscribe(
      res => {
        //
        this.linea = res[0];
        
        this.formTEM.controls['Adelanto_Porcentaje'].setValue( this.linea["Campo_3"]);
        this.formTEM.controls['Aforo_Porcentaje'].setValue( this.linea["Campo_4"]);
        this.formTEM.controls['Comision_Porcentaje'].setValue( this.linea["Campo_1"]); 
        this.formTEM.controls['Prorroga_Porcentaje'].setValue( this.linea["Campo_10"]); 
        
        let comision = this.totalVnpp*(this.linea["Campo_3"]/100) * this.linea["Campo_1"]/100;
        
        this.formTEM.controls['Comision'].setValue(Math.round(comision*100)/100);
        this.TemEdit = ( this.linea["Campo_2"] / 100);
        this.TEM = ( this.linea["Campo_2"] / 100);
        this.flgTEMAutomatico = false; 
        //this.calcularProforma(true, this.TemEdit);
        
        //this.calcularComision();
      },err => {
        let error = "";
          error = err.error.error;
          this.formTEM.controls['Ranking'].setValue(0);
        this.showNotification('warning', 'top', 'right', 'Error al intentar obtener datos de Linea. \n Error: ' + error);
        this.boton = true;
      }
    );
  }

  validarProvAdq(rucProv, rucAdq) {
    let proveedoresArr = [];
    let adquirentessArr = [];
  

    proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));

    for (let item of proveedoresArr) {
      if (item.Num_Doc_Identificacion == rucProv && item.Estado != "A") {

        Swal.fire({
          title: '¡Alto!',
          text: this.Label_Proveedor+' bloqueado, no puede continuar.',
          type: 'error',
          allowOutsideClick: false,
          heightAuto: false
        });
        this.loginService.clickGuard = true;
        this.router.navigate(["/operaciones/proformas/documentos"]);
        this.ObtenerDocumentosNegociables();
        break;
      }
    }

    for (let item of adquirentessArr) {
      if (item.Num_Doc_Identificacion == rucAdq && item.Estado != "A") {

        Swal.fire({
          title: '¡Alto!',
          text: this.Label_Adquirente+' bloqueado, no puede continuar.',
          type: 'error',
          allowOutsideClick: false,
          heightAuto: false
        });
        this.loginService.clickGuard = true;
        this.router.navigate(["/operaciones/proformas/documentos"]);
        this.ObtenerDocumentosNegociables();
        break;
      }
    }

 
  }

  tipoServicio(event) {

    this.formTEM.controls['Tipo_Servicio'].setValue(event);
    this.IGV_Porcentaje = this.igvPorcentajeGlobal;

    if (this.formTEM.controls.Tipo_Servicio.value == this.Id_Factoring  ) {
      this.formTEM.controls['Interes_Adquirente'].setValue('0');
      this.formTEM.controls['Importe_Adquirente'].setValue('0');
      this.IGV_Porcentaje = 0;
    }else if(  this.formTEM.controls.Tipo_Servicio.value == this.Id_Descuento) {
      this.formTEM.controls['Interes_Adquirente'].setValue('0');
      this.formTEM.controls['Importe_Adquirente'].setValue('0');
      this.IGV_Porcentaje = 0;
      this.loading = true;
       

          this.cobranzasService.ObtenerCuotasPago(this.datosDN.TipoMoneda, this.datosDN.idProveedor).subscribe(
            res => {
              let data :any = res ;
              this.operacionProv = data.filter(x => x.Serie == 'OPE');
              
              
              this.loading = false; 
            })
    }else{
      this.formTEM.get('Interes_Adquirente').setValue('100');
      this.formTEM.get('Adelanto_Porcentaje').setValue('100');
    }

    this.resetear();
  }

  ObtenerDocumentosNegociables() {

    this.loading = true;

    let Datos: any = {
      Tipo_Comprobante: '',
      Moneda: 0,
      Num_Doc_IdentificacionProv: '',
      Num_Doc_IdentificacionADQ: '',
      Tipo_Operacion: 'PR'
    };

    Datos.Tipo_Comprobante = this.datosDN.Tipo_Comprobante;
    Datos.Moneda = this.datosDN.TipoMoneda;
    Datos.Num_Doc_IdentificacionProv = this.datosDN.Num_Doc_Identificacion_Prov;
    Datos.Num_Doc_IdentificacionADQ = this.datosDN.Num_Doc_Identificacion_Adq;

    this.proformaService.ObtenerDocumentosNegociables(Datos).subscribe(
      res => {
        this.arrayDocumentos = res;
        this.resetear();
        this.ObtenerRanking();
        this.loading = false;
      });
  }

  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return (Math.floor(((utc1 - utc2) / this.MILISENGUNDOS_POR_DIA))+1);
  }

  resetear(){
    this.flgCalcular = false;
    this.proformaDetalle = [];
    this.totalVnpp = 0;
    this.arrayDocumentos.forEach((item,index) => {
      this.proformaDetalle.push(item as ProformaDetalle);
      
      let fecha = moment(item.Fecha_de_Pago);
      let fechaDesembolso = (this.flagRepro)? moment(item.Fecha_de_Pago_Original)['_d']:this.formTEM.controls['Fecha_Desembolso'].value._d;
      
      this.proformaDetalle[index].Plazo = this.diferenciaEntreDiasEnDias(this.formTEM.controls['Fecha_Pago_Operacion'].value._d, this.formTEM.controls['Fecha_Desembolso'].value._d);
      //this.formTEM.controls['PlazoProforma'].setValue(this.proformaDetalle[index].Plazo);
      //this.proformaDetalle[index].Plazo = this.diferenciaEntreDiasEnDias(fecha['_d'], fechaDesembolso);
      this.proformaDetalle[index].Adelanto_importe = 0;
      this.proformaDetalle[index].Interes_importe = 0;
      this.proformaDetalle[index].Comision_importe = 0;
      this.proformaDetalle[index].InteresAdq = 0;
      this.proformaDetalle[index].InteresProv = 0;
      this.proformaDetalle[index].IGV_Importe = 0;
      this.proformaDetalle[index].Desembolso_importe = 0;
      this.proformaDetalle[index].Remanente_importe = 0;
      this.proformaDetalle[index].IGVProv = 0;
      this.proformaDetalle[index].DesembolsoProvConfirming = 0;
      this.proformaDetalle[index].ComisionTotal = 0;
      this.proformaDetalle[index].IGV_porcentaje = 0;
      this.proformaDetalle[index].IGVAdq = 0;
      this.proformaDetalle[index].Porcentaje_Interes_Adquirente = 0;
      //this.proformaDetalle[index].checked = true;

      this.totalVnpp = this.totalVnpp+Number(this.proformaDetalle[index].VNPP);
    });

    this.ProformaTotales = {
      VNPP: 0,
      Adelanto: 0,
      Interes: 0,
      InteresAdq: 0,
      InteresProv: 0,
      Comision: 0,
      IGV_TOTAL: 0,
      Desembolso: 0,
      Remanente: 0,
      IGVProv: 0,
      CAVALI : 0,
      Firma : 0,
      Otros : 0,
      Desembolso_importe : 0, 
      DesembolsoProvConfirming: 0,
      Costo_Total_Operacion : 0
    };

  }

  guardarProforma() {

    this.proformaGeneral.ProformaDetalle = [];
    this.proformaGeneral.Num_Doc_Identificacion_Prov = this.datosDN.Num_Doc_Identificacion_Prov;
    this.proformaGeneral.Num_Doc_Identificacion_ADQ = this.datosDN.Num_Doc_Identificacion_Adq;
    this.proformaGeneral.Ranking_Adquirente = this.formTEM.controls['Ranking'].value;
    this.proformaGeneral.Tasa_Tipo_de_Calculo = 'M';
    this.proformaGeneral.Tasa_Mensual_Sistema = this.TEMAutomatico;
    this.proformaGeneral.Tasa_Mensual = this.TEM;
    this.proformaGeneral.Tasa_Anual = this.TEM;
    this.proformaGeneral.Tasa_Diaria = this.TEM;
    this.proformaGeneral.Moneda = this.datosDN.TipoMoneda;
    this.proformaGeneral.Adelanto_porcentaje = this.formTEM.controls['Adelanto_Porcentaje'].value / 100;
    this.proformaGeneral.Fecha_Desembolso = this.datepipe.transform(this.formTEM.controls['Fecha_Desembolso'].value, 'yyyy-MM-dd');
    this.proformaGeneral.Tipo_Servicio = this.formTEM.controls['Tipo_Servicio'].value;
    this.proformaGeneral.Porcentaje_Interes_Adquirente = this.formTEM.controls['Interes_Adquirente'].value / 100;
    this.proformaGeneral.Alta_Usuario = this.user.Usuario;
    this.proformaGeneral.TAI = this.ProformaTotales.TAI;
    this.proformaGeneral.IdOpeNova = this.formTEM.controls['IdOpeNova'].value;
    this.proformaGeneral.TasaProrroga = this.formTEM.controls['Prorroga_Porcentaje'].value /100;
    let now = moment();
    let FVig = now.add(this.PlazoMaximo, 'days');

    this.proformaGeneral.Fecha_Vigencia = this.datepipe.transform(FVig, 'yyyy-MM-dd');
    this.proformaGeneral.Cantidad_de_Documentos_Negociables = 0;

    this.actualizarDocumentos = [];
    for (let item of this.proformaDetalle) {
      if (item.checked) {

        if (item.Plazo < this.varDiasMin) {
          Swal.fire({
            title: `${this.msgTitulos.Error_Fuera_Rango}`,
            text: `${this.msgAgregarSimulador.Error_Plazo_Dias}`,
            heightAuto: false
          });
          return;
        }

        if (item.DesembolsoProvConfirming <= 0) {
          Swal.fire({
            title: `${this.msgTitulos.Error_Valor_Negativo}`,
            text: `${this.msgAgregarSimulador.Error_Desemboldo}`,
            heightAuto: false
          });
          return;
        }
        item.Tasa = 0;
        item.Tasa_Comision = 0;
        this.actualizarDocumentos.push({ "idComprobante": String(item.idComprobante), "Estado": "T" });
        this.proformaGeneral.Cantidad_de_Documentos_Negociables += 1;
        this.proformaGeneral.ProformaDetalle.push(item);

      }
    }

    if (this.proformaGeneral.ProformaDetalle.length <= 0) {
      Swal.fire({
        title: "Atención",
        text: "Seleccione al menos un documento",
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    }

    Swal.fire({
      title: 'Espere',
      text: 'Guardando información',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.proformaService.CrearProforma(this.proformaGeneral).subscribe(
      responseProforma => {
        this.ProformaSave = responseProforma;
        this.idProforma = this.ProformaSave.idProforma;
        this.idProveedor = this.ProformaSave.idProveedor;

        this.empresasService.obtenerContactosEmpresa(this.idProveedor.toString()).subscribe(
          res => {
            this.rProveedor = res;
            // Buscando tipos de Contactos --Representante Legal
            let tipoContacto: any = [];
            let guiaTipo: any;
            this.guiasService.TipoContacto.subscribe(
              response => {
                tipoContacto = response;
                guiaTipo = tipoContacto.find(state => state.Codigo.toLowerCase().indexOf('rl') === 0)
              }
            );

            this.rProveedor = this.rProveedor.filter(
              state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 && state.Tipo_de_Contacto === guiaTipo.idGuia
            );

            if (this.rProveedor.length > 0) {
              this.correo = this.rProveedor[0].Correo.trim();
              this.Nombre_de_Contacto = this.rProveedor[0].Nombre_de_Contacto.trim();
              Swal.fire({
                title: 'Registrado con éxito',
                html: '¿Deseas enviar el pdf al correo electrónico <b>' + this.correo + '</b>?',
                type: "success",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                heightAuto: false
              }).then((result) => {
                if (result.value) {
                  let $body: any;
                  $body = { 'idProforma': this.idProforma.toString(), 'nombre': this.Nombre_de_Contacto, 'correo': this.correo };

                  this.proformaService.enviarProformaProv($body).subscribe(
                    res2 => {
                      this.showNotification('success', 'top', 'right', 'Correo enviado exitosamente.');
                    }, err => {
                      let error = "";
                      error = err.error.error;
                      this.showNotification('warning', 'top', 'right', 'Error al intentar enviar correo. \n Error: ' + error);
                    }
                  );
                }
                window.open(this.ProformaSave.Adjunto_PDF, "_blank");
                this.loginService.clickGuard = true;
                this.router.navigate(["/operaciones/proformas/listado"]);
              });
            } else {
              Swal.fire({
                title: 'Registrado con éxito',
                type: 'success',
                allowOutsideClick: true
              });
              window.open(this.ProformaSave.Adjunto_PDF, "_blank");
              this.loginService.clickGuard = true;
              this.router.navigate(["/operaciones/proformas/listado"]);
            }
          }, (err: HttpErrorResponse) => {
            Swal.fire({
              title: 'Registrado con éxito',
              type: 'success',
              footer: 'Contactos no obtenidos',
              allowOutsideClick: true,
              heightAuto: false
            });
            window.open(this.ProformaSave.Adjunto_PDF, "_blank");
            this.loginService.clickGuard = true;
            this.router.navigate(["/operaciones/proformas/listado"]);
          }
        );
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error.code == 500) {
          err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
        }
        Swal.fire({
          title: "Ha ocurrido un error",
          text: err.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }

  validar(){
    if (this.formTEM.controls.Tipo_Servicio.value == this.Id_Factoring || this.formTEM.controls.Tipo_Servicio.value == this.Id_Descuento) {
      this.proformaGeneral.Porcentaje_Interes_Adquirente = 0
    }

    
    for (let item of this.proformaDetalle) {
      if (item.checked) {

        if (item.Plazo < this.varDiasMin) {
          Swal.fire({
            title: `${this.msgTitulos.Error_Fuera_Rango}`,
            text: `${this.msgAgregarSimulador.Error_Plazo_Dias}`,
            heightAuto: false
          });
          return;
        }

        if (item.Desembolso_importe <= 0) {
          Swal.fire({
            title: `${this.msgTitulos.Error_Valor_Negativo}`,
            text: `${this.msgAgregarSimulador.Error_Desemboldo}`,
            heightAuto: false
          });
          return;
        }

      
        item.Factoring_importe = item.Interes_importe + item.Comision_importe;
        item.Factoring_SUNAT_importe = item.Interes_importe + item.Comision_importe + item.IGV_Importe;
        this.proformaGeneral.Cantidad_de_Documentos_Negociables += 1;
        this.proformaGeneral.ProformaDetalle.push(item);

      }
    }

    if (this.proformaGeneral.ProformaDetalle.length <= 0) {
      Swal.fire({
        title: "Atención",
        text: "Seleccione al menos un documento",
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
    }
  }

  actualizarDocumentosN(docs: any[]) {
    for (let item of docs) {
      this.documentoNegociableService.CambiarEstadoComprobante(item, item.idComprobante).subscribe(
        res => {
          console.log('Documento Negociable actualizado')
        });
    }
  }

  editarTEM() {
    Swal.fire({
      title: 'Ingresar TEM',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Cambiar',
      reverseButtons: true,
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      heightAuto: false,
    }).then((result) => {
      if (result.dismiss) {
        return;
      }
      if (result.value < (this.varTasaMin * 100) || result.value > (this.varTasaMax * 100)) {
        Swal.fire({
          title: `${this.msgTitulos.Error_Fuera_Rango}`,
          text: `${this.msgAgregarSimulador.Error_TEM}`,
          heightAuto: false
        })
        return;
      }
      this.TemEdit = (result.value / 100);
      this.calcularProforma(false, this.TemEdit);
    })
  }

  showNotification(type, from, align, message) {

    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal

    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

  calculateFechaPago(value:any){
      console.log(this.formTEM.controls['PlazoProforma'].value);

      let now  =    moment(this.formTEM.controls['Fecha_Desembolso'].value);
      now.add(this.formTEM.controls['PlazoProforma'].value-1, 'days');
      
      this.formTEM.controls['Fecha_Pago_Operacion'].setValue(now);
      for (let index = 0; index < this.proformaDetalle.length; index++) {
        this.proformaDetalle[index].Fecha_de_Pago = now;
      }
      this.resetear();
  }


  calcularProrroga(){
      //Prorroga_Porcentaje 
console.log('---',this.ProformaTotales);
      if(this.ProformaTotales.Desembolso_importe > 0){
        let prorroga = Math.round((this.ProformaTotales.Desembolso_importe * this.formTEM.controls['Prorroga_Porcentaje'].value/100)*100)/100;
        console.log('---',prorroga);
        this.formTEM.get('Prorroga_Monto').setValue(prorroga);
        this.formTEM.get('Prorroga_Iva').setValue(Math.round(prorroga*.12*100)/100);
        this.formTEM.get('Prorroga_Total').setValue(Math.round(prorroga*1.12*100)/100);

        this.formTEM.get('Prorroga_Monto').disable();
        this.formTEM.get('Prorroga_Iva').disable();
        this.formTEM.get('Prorroga_Total').disable();
      } 
  }

  formatearMoneda(campo: string): string {
    const valor = this.formTEM.get(campo).value;

    if (valor === null || valor === undefined || valor === '') {
      return '0.00';
    }

    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(valor));
  }

  seleccionarOperacion(item :string){

  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return (control && control.invalid);
  }
}